export default "/fonts/Muli-BlackItalic.ttf?1add3a2ca24713d973af8bdac2eb28e8";